/**
 * Modello dati per la LeadInformation.
 * Analogo a `CompanyInformation` ma con `LeadOid` come chiave di relazione.
 *
 * Un record per ogni campo informativo del lead (es. telefono, email, ecc.)
 * identificato dal valore numerico dell'enum `ContactInformationTypeVO`.
 */
export class LeadInformation {

  Oid?: number;
  LeadOid: number | null = null;
  Content: any | null = null;
  // Type è un intero sul backend (valore enum ContactInformationTypeVO)
  Type: number | null = null;

  private constructor() {}

  public static create = () => new LeadInformation();

  setLeadOid(value: number | null): LeadInformation {
    this.LeadOid = value;
    return this;
  }

  setContent(value: any | null): LeadInformation {
    this.Content = value;
    return this;
  }

  /**
   * Converte esplicitamente il code (stringa dal JSON) a numero intero
   * per rispettare il tipo atteso dal backend.
   */
  setType(value: string | null): LeadInformation {
    this.Type = value != null ? parseInt(value, 10) : null;
    return this;
  }

}
